import { useEffect, useState } from 'react';
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout';
import { EditPlan } from './Components/Membership/EditPlan';
import { ViewPlan } from './Components/Membership/ViewPlan';
import { useSearchParams } from 'react-router-dom';


export const Membership= () => {
    /* ******************** Hooks ******************** */
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode')
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            {
                mode == 'view' ?
                <ViewPlan /> :
                <EditPlan />
            }
        </KaziLayout>
    )
}